import { MoneyValueDto } from '@/types/MoneyValueDto.ts';
import { Currency } from '@/features/dashboard/paymentConfig/types/Currency.ts';

/** Czym organizator oddaje nadpłatę po rezygnacji. */
export enum RefundChannel {
  TPAY = 'TPAY',
  TRANSFER = 'TRANSFER',
  CASH = 'CASH',
}

/**
 * Potrącenie za odstąpienie, po jednej kwocie na walutę. Waluty spoza mapy
 * znaczą „bez potrącenia”, więc pusta mapa jest legalna.
 */
export type WithdrawalFeesDto = Partial<Record<Currency, number>>;

/** Podgląd rozliczenia rezygnacji — nic nie zapisuje. */
export interface WithdrawalPreviewRequest {
  participantIds: string[];
  fees: WithdrawalFeesDto | null;
}

/**
 * Wprowadzenie rezygnacji. Dzieje się **natychmiast**: backend zakłada osobną
 * paczkę `WITHDRAWAL` i od razu ją wprowadza, więc nie ma tu ani szkicu, ani
 * akceptacji klienta.
 *
 * `justification` jest obowiązkowe (art. 47), a kanał zwrotu podaje się per
 * waluta — waluta bez wskazania dostaje przelew.
 */
export interface ExecuteWithdrawalRequest {
  participantIds: string[];
  fees: WithdrawalFeesDto | null;
  refundChannels: Partial<Record<Currency, RefundChannel>> | null;
  justification: string;
}

/**
 * Rozliczenie rezygnacji po jednej pozycji na walutę — ta sama odpowiedź wraca
 * z podglądu i z wprowadzenia.
 */
export interface WithdrawalSettlementLineDto {
  /** Udział odchodzących w wartości rezerwacji. */
  share: MoneyValueDto;
  /** Potrącenie zatrzymane przez organizatora. */
  fee: MoneyValueDto;
  paid: MoneyValueDto;
  /** Należność rezerwacji po rezygnacji. */
  liabilityAfter: MoneyValueDto;
  /** Do oddania klientowi; zero, gdy nie ma nadpłaty. */
  refund: MoneyValueDto;
  /** Do dopłaty przez klienta; zero, gdy nie ma niedopłaty. */
  debt: MoneyValueDto;
}

export interface WithdrawalSettlementDto {
  /** Czy odchodzą wszyscy — rezygnacja z całej rezerwacji. */
  total: boolean;
  lines: WithdrawalSettlementLineDto[];
}
